import RequestFunderInfoContainer from 'containers/RequestFunderInfo'
import React from 'react'

const RequestFunderInfoPage = () => <RequestFunderInfoContainer />

export default RequestFunderInfoPage
